import { render } from "./legalVue.vue?vue&type=template&id=74eba6a2"
const script = {}

import "./legalVue.vue?vue&type=style&index=0&id=74eba6a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__